import unicodeTrie from 'unicode-trie';

var XX = 0; // Unknown

// WordBreakProperty.txt
var Double_Quote = 1;
var Single_Quote = 2;
var Hebrew_Letter = 3;
var CR = 4;
var LF = 5;
var Newline = 6;
var Extend = 7;
var Regional_Indicator = 8;
var Format = 9;
var Katakana = 10;
var ALetter = 11;
var MidLetter = 12;
var MidNum = 13;
var MidNumLet = 14;
var Numeric = 15;
var ExtendNumLet = 16;
var ZWJ = 17;
var WSegSpace = 18;

// emoji-data.txt
var Extended_Pictographic = 19;

// mapped classes in Unicode 12
var AHLetter = 20;
var MidNumLetQ = 21;

var classes = {
	XX: XX,
	Double_Quote: Double_Quote,
	Single_Quote: Single_Quote,
	Hebrew_Letter: Hebrew_Letter,
	CR: CR,
	LF: LF,
	Newline: Newline,
	Extend: Extend,
	Regional_Indicator: Regional_Indicator,
	Format: Format,
	Katakana: Katakana,
	ALetter: ALetter,
	MidLetter: MidLetter,
	MidNum: MidNum,
	MidNumLet: MidNumLet,
	Numeric: Numeric,
	ExtendNumLet: ExtendNumLet,
	ZWJ: ZWJ,
	WSegSpace: WSegSpace,
	Extended_Pictographic: Extended_Pictographic,
	AHLetter: AHLetter,
	MidNumLetQ: MidNumLetQ
};

const {
  Double_Quote: Double_Quote$1,
  Single_Quote: Single_Quote$1,
  Hebrew_Letter: Hebrew_Letter$1,
  CR: CR$1,
  LF: LF$1,
  Newline: Newline$1,
  Extend: Extend$1,
  Regional_Indicator: Regional_Indicator$1,
  Format: Format$1,
  Katakana: Katakana$1,
  ALetter: ALetter$1,
  MidLetter: MidLetter$1,
  MidNum: MidNum$1,
  MidNumLet: MidNumLet$1,
  Numeric: Numeric$1,
  ExtendNumLet: ExtendNumLet$1,
  ZWJ: ZWJ$1,
  WSegSpace: WSegSpace$1,
  Extended_Pictographic: Extended_Pictographic$1,
  AHLetter: AHLetter$1,
  MidNumLetQ: MidNumLetQ$1
} = classes;

const classTrie = new unicodeTrie(Buffer("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","base64"));

// table 3a
function mapClass(c) {
  switch (c) {
    case ALetter$1:
    case Hebrew_Letter$1:
      return AHLetter$1;

    case MidNumLet$1:
    case Single_Quote$1:
      return MidNumLetQ$1;

    default:
      return c;
  }
}

class WordBreaker {
  constructor(charProvider) {
    this.charProvider = charProvider;
    this.pos = 0;
    this.nextClass = null;
    this.riCount = 0;
  }

  nextCodePoint() {
    const code = this.charProvider.charCodeAtPos();
    this.pos++;
    this.charProvider.advancePos();
    const next = this.charProvider.charCodeAtPos();

    // If a surrogate pair
    if ((0xd800 <= code && code <= 0xdbff) && (0xdc00 <= next && next <= 0xdfff)) {
      this.pos++;
      this.charProvider.advancePos();
      return ((code - 0xd800) * 0x400) + (next - 0xdc00) + 0x10000;
    }

    return code;
  }

  nextCharClass() {
    return classTrie.get(this.nextCodePoint());
  }

  nextBreak() {
    while (this.charProvider.moreChar()) {
      let lastClass, curClass, nextClass;

      this.lastPos = this.pos;
      this.curClass = this.nextClass;
      if (!this.inSeq) {
        this.last4Class = this.cur4Class;
        this.cur4Class = this.nextClass;
      }
      this.nextClass = this.nextCharClass();

      this.inSeq = false;

      if (this.curClass == null) {
        //return 0; // WB1
        continue
      }

      curClass = this.curClass;
      nextClass = this.nextClass;

      // WB3
      if (curClass === CR$1 && nextClass === LF$1) continue;

      // WB3a
      if (curClass === Newline$1 || curClass === CR$1 || curClass == LF$1){
        return {pos: this.lastPos, type: curClass};
      }


      // WB3b
      if (nextClass === Newline$1 || nextClass === CR$1 || nextClass == LF$1){
        return {pos: this.lastPos, type: curClass};
      }


      // WB3c
      if (curClass === ZWJ$1 && nextClass === Extended_Pictographic$1) continue;

      // WB3d
      if (curClass === WSegSpace$1 && nextClass === WSegSpace$1) continue;

      // WB4
      if (nextClass === Extend$1 || nextClass === Format$1 || nextClass === ZWJ$1) {
        this.inSeq = true;
        continue;
      }

      lastClass = this.last4Class;
      curClass = this.cur4Class;

      const mcurClass = mapClass(curClass);
      const mnextClass = mapClass(nextClass);

      // WB5
      if (mcurClass === AHLetter$1 && mnextClass === AHLetter$1) continue;

      let peekNext;
      const restorePos = this.pos;
      this.charProvider.posSave();
      do peekNext = this.nextCharClass();
      while (peekNext === Extend$1 || peekNext === Format$1 || peekNext === ZWJ$1);
      this.pos = restorePos;
      this.charProvider.posRestore();

      const mpeekNext = mapClass(peekNext);
      const mlastClass = mapClass(lastClass);

      if (curClass === Regional_Indicator$1) {
        this.riCount += 1;
      } else {
        this.riCount = 0;
      }

      // WB6
      if (mcurClass === AHLetter$1 && (nextClass === MidLetter$1 || mnextClass === MidNumLetQ$1) && mpeekNext === AHLetter$1) continue;
      
      // WB7
      if (mlastClass === AHLetter$1 && (curClass === MidLetter$1 || mcurClass === MidNumLetQ$1) && mnextClass === AHLetter$1) continue;

      // WB7a
      if (curClass === Hebrew_Letter$1 && nextClass === Single_Quote$1) continue;

      // WB7b
      if (curClass === Hebrew_Letter$1 && nextClass === Double_Quote$1 && peekNext === Hebrew_Letter$1) continue;

      // WB7c
      if (lastClass === Hebrew_Letter$1 && curClass === Double_Quote$1 && nextClass === Hebrew_Letter$1) continue;

      // WB8
      if (curClass === Numeric$1 && nextClass === Numeric$1) continue;

      // WB9
      if (mcurClass === AHLetter$1 && nextClass === Numeric$1) continue;

      // WB10
      if (curClass === Numeric$1 && mnextClass === AHLetter$1) continue;

      // WB11
      if (lastClass === Numeric$1 && (curClass === MidNum$1 || mcurClass === MidNumLetQ$1) && nextClass === Numeric$1) continue;

      // WB12
      if (curClass === Numeric$1 && (nextClass === MidNum$1 || mnextClass === MidNumLetQ$1) && peekNext === Numeric$1) continue;

      // WB13
      if (curClass === Katakana$1 && nextClass === Katakana$1) continue;

      // WB13a
      if ((mcurClass === AHLetter$1 || curClass ===  Numeric$1 || curClass === Katakana$1 || curClass === ExtendNumLet$1) && nextClass === ExtendNumLet$1) continue;

      // WB13b
      if (curClass === ExtendNumLet$1 && (mnextClass === AHLetter$1 || nextClass === Numeric$1 || nextClass === Katakana$1)) continue;

      // WB15, WB16
      if (curClass === Regional_Indicator$1 && nextClass === Regional_Indicator$1) {
        if (this.riCount % 2 === 1) continue;
      }

      // WB999
      return {pos: this.lastPos, type: curClass};
    }

    if (this.pos && !this.end) {
      this.end = true;
      return {pos: Infinity, type: this.curClass};// WB2
    }

    return null;
  }
}
var src = {classes, WordBreaker};
var src_1 = src.classes;
var src_2 = src.WordBreaker;

export default src;
export { src_2 as WordBreaker, src_1 as classes };
